module.exports = __webpack_public_path__ + "static/media/background-2.dc779ded.jpg";